import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { AppBarAppMobileTeleporter } from "@sprout/client-components/dist/AppBar";
import { Link } from "react-router-dom";
const InviteButton = styled(Button)`
  margin-left: auto;
`;
const TopicMembersPageAppBarMobile = (props)=>{
    const { inviteURL  } = props;
    return /*#__PURE__*/ _jsx(AppBarAppMobileTeleporter, {
        children: /*#__PURE__*/ _jsx(InviteButton, {
            variant: "bright-teal",
            as: Link,
            to: inviteURL,
            children: "Invite"
        })
    });
};
export default TopicMembersPageAppBarMobile;
